import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";

import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { UserNotificationListResponse } from "@app/core/notifications/domain/user-notification-list-response";
import { UserNotificationListResponseMapper } from "@app/core/notifications/data/network/user-notification-list-response.mapper";

@Injectable({
  providedIn: "root",
})
export class GetNotificationsListWebService {
  constructor(private handler: BaseHandler) {}

  execute(token: string): Observable<UserNotificationListResponse> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.get)
      .setUrl(ApiUrls.GET_NOTIIFCATIONS_ENDPOINT())

      .setAuthorization(new TokenAuthorization(token))
      .build();

    return this.handler
      .execute(parameters)
      .pipe(map(UserNotificationListResponseMapper.deserialize));
  }
}
